module.exports = __webpack_public_path__ + "static/media/tap.cf5efc3b.m4a";